module.exports = __webpack_public_path__ + "static/3-67e6cfacdc365bc2506a60a7672486d5.jpg";